import React, { Component } from 'react';
import { Modal, Row, Col, Input, Radio, message } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';
import ExportUtil from '../../common/ExportUtil';

const TextArea = Input.TextArea;
const RadioGroup = Radio.Group;

class AddNextWeekPlan extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    }
   
    show = params => {
        this.setState({
            visible: true,
            ...params,
        });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    handleSubmit = () => {
        const { type, userId, roleId, enterpriseWorkNameValue, startDate, endDate, investigationId, investigationSiteId } = this.state;
        const url = type == 'comment' ? API_URL.manhour.addUserWeeklyComment : API_URL.manhour.addNextWeekly;
        const options = {
            method: 'POST',
            url,
            data: {
                roleId,
                userId,
                endDate,
                startDate,
                investigationId,
                investigationSiteId,
                comment: enterpriseWorkNameValue,
            },
            dataType: 'json',
            doneResult: ( res => {
                if (res.success) {
                    message.success(res.success);
                } else if (res.error) {
                    message.error(res.error);
                }
                this.setState({ visible: false });
                this.props.reload();
            }),
        };
        AjaxRequest.sendRequest(options);
    };

    onTextAreaChange = e => {
        this.setState({ enterpriseWorkNameValue: e.target.value });
    }

    render() {
        const { visible, confirmLoading, enterpriseWorkNameValue, type } = this.state;
        return (
            <Modal
                title={type == 'comment' ? "填写本周备注" : "填写下周计划"}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <Row>
                    <Col span={5}>{`${type == 'comment' ? "本周备注" : "下周计划"}：`}</Col>
                    <Col span={18}>
                        <TextArea placeholder={`请填写${type == 'comment' ? "本周备注" : "下周计划"}：`} value={enterpriseWorkNameValue} rows={4} onChange={this.onTextAreaChange} />
                    </Col>
                </Row>
            </Modal>
        );
    }
}

class ExportModal extends Component {
    state = {
        visible: false,
    }

    show = (searchParams) => {
        this.setState({
            flag: 1,
            searchParams,
            visible: true,
        });
    }

    handleOk = () => {
        const { flag, searchParams } = this.state;

        ExportUtil.export({ flag, ...searchParams }, null, API_URL.manhour.exportManHourWeek);
        this.setState({ visible: false });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ flag: e.target.value });
    }

    render () {
        const { visible, flag } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label">是否导出进展信息?</label>
                            </div>
                            <div className="item" style={{ marginLeft: 24 }}>
                                <RadioGroup onChange={this.onChange} value={flag}>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export { AddNextWeekPlan, ExportModal };



// WEBPACK FOOTER //
// ./src/components/manHour/MyWeeklyModal.js